import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Scheduler from './icon-scheduler.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Scheduler {...validProps} />;
}
SvgComponent.iconName = 'scheduler';

export const SchedulerIcon = svgIconWrapper(SvgComponent);
